<template>
	<v-toolbar flat color="primary" height="29px">
		<v-toolbar-items>
			<div class="label-status">ステータス：</div>
			<v-btn-toggle v-model="toggleStatus" multiple mandatory class="transparent pr-2" max="100px" style="height: 30px;">
				<v-btn flat large class="white--text" :value="toggle_status.PROGRESS">未完了</v-btn>
				<v-btn flat large class="white--text" :value="toggle_status.DONE">完了</v-btn>
			</v-btn-toggle>
		</v-toolbar-items>
	</v-toolbar>
</template>
<script>
import { FILTERING_STATUS } from '../data/Const';

const clonedeep = require('lodash/cloneDeep');

export default {
	name: 'GBHeaderSimpleDisplaySwitch',
	data() {
		return {
			toggle_status: {
				PROGRESS: 1,
				DONE: 2,
			},
			toggleStatus: new Array(),
		}
	},
	watch: {
		toggleStatus: function(val) {
			let filter_value = clonedeep(this.$store.getters.scheduleFilter);
			let filter_status = 0;
			val.forEach(v => {
				filter_status += v;
			});
			switch(filter_status) {
				case 1:	filter_value.status = FILTERING_STATUS.PROGRESS;break;
				case 2:	filter_value.status = FILTERING_STATUS.DONE;	break;
				case 3: filter_value.status = FILTERING_STATUS.ALL;		break;
				default: break;
			}
			this.$store.dispatch('updateScheduleFilter', filter_value);
		},
	},
	mounted: function() {
		let toggle_value = new Array();
		switch(this.$store.getters.scheduleFilter.status) {
			case FILTERING_STATUS.ALL:
				toggle_value.push(this.toggle_status.DONE, this.toggle_status.PROGRESS);
				break;
			case FILTERING_STATUS.DONE:
				toggle_value.push(this.toggle_status.DONE);
				break;
			case FILTERING_STATUS.PROGRESS:
				toggle_value.push(this.toggle_status.PROGRESS);
				break;
			default:
				break;
		}
		this.toggleStatus = toggle_value;
	},
}
</script>
<style scoped>
.label-status {
	color: white;
	line-height: 30px;
	user-select: none;
}
</style>

